"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = { enrolledPrograms: [] };
    },
    onMount: function () {
        this.fetchPrograms();
    },
    fetchPrograms: async function () {
        try {
            const {error, message, results} = await Request('/learner/program/enrolled/list');
            if (error)
                console.log('Error Fetching Enrolled Programs: ', message);
            this.state.enrolledPrograms = results || [];
        } catch (error) {
            console.log('Error Fetching Enrolled Programs');
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Dashboard/Learner/components/MyPrograms.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_forRange = require("marko/dist/runtime/helpers/for-range"),
    EnrolItem_template = require("../../../../components/EnrolItem.marko"),
    EnrolItem_tag = marko_loadTag(EnrolItem_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    marko_attrs0 = {
        "class": "mx-1 my-2",
        id: "my-programs"
      },
    marko_attrs1 = {
        "class": "card"
      },
    marko_attrs2 = {
        "class": "list-group"
      },
    marko_attrs3 = {
        "class": "list-group-item only-dark-bg-fade border-bottom"
      },
    marko_attrs4 = {
        "class": "text-right"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("section", marko_attrs0, "0", component);

  if (state.enrolledPrograms.length) {
    out.be("h6", null, "1", component);

    Locale_tag({
        text: "My Programs"
      }, out, __component, "2");

    out.ee();

    out.be("div", marko_attrs1, "3", component);

    out.be("ul", marko_attrs2, "4", component);

    const displayLimit = state.enrolledPrograms.length > 4 ? 4 : state.enrolledPrograms.length - 1

    var $for$0 = 0;

    marko_forRange(0, displayLimit, 1, function(index) {
      var $keyScope$0 = "[" + (($for$0++) + "]");

      EnrolItem_tag(state.enrolledPrograms[index], out, __component, "5" + $keyScope$0);
    });

    if ((state.enrolledPrograms.length - 1) > displayLimit) {
      out.be("li", marko_attrs3, "6", component);

      out.be("div", marko_attrs4, "7", component);

      route_link_tag({
          href: "/courses?type=enrolled",
          renderBody: function(out) {
            Locale_tag({
                text: "View all",
                class: "text-primary"
              }, out, __component, "9");
          }
        }, out, __component, "8");

      out.ee();

      out.ee();
    }

    out.ee();

    out.ee();
  }

  out.be("div", null, "10", component);

  route_link_tag({
      href: "/explore",
      class: "btn btn-outline-secondary btn-lg",
      renderBody: function(out) {
        Locale_tag({
            text: "Explore Programs"
          }, out, __component, "12");
      }
    }, out, __component, "11");

  out.ee();

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
